import React from 'react';
import ModalButton from './ModalButton';

const PersonalAccountModal = ({email, proceed, closeModal})=>{
	return <div>
		<div>Thank you for your interest in Jumbletree LEARN.  <strong>{email}</strong>&nbsp;
		looks like a personal email address.  Personal accounts are locked to your email only, so
		if you're signing up for your school please go back and use your <em>school.nz</em> email 
		address instead.
		<br />
		<br />
		By continuing today	you'll be starting your personal free trial.  You'll
		be able to create up to five homework sheets for free, and if you wish to continue using
		Jumbletree LEARN after this you'll be able to sign up for a pay-as-you-go account. </div>
		<ModalButton text="Start FREE TRIAL" onClick={proceed} showBail={true} bail={closeModal} />
	</div>
}

export default PersonalAccountModal;